import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import {
  FormSection,
  RequiredNote,
  SelectField,
  TextField,
} from '../../../../../Components/Form';
import { FOB_INCOTERM_ID, TIMELINE_OPTIONS } from '../shared/constants';
import { formatParcelSize, needsLocationQuantity } from '../shared/utils';
import {
  CounterProductAlert,
  CounterModalLoading,
  CounterModalFooter,
  CounterDeliveryBasisFields,
  CounterPortPick,
  CounterPortBlock,
  CounterDischargePorts,
  getCounterPortCount,
} from '../shared/counterOfferShared';
import '../shared/counterIncoterm.css';

const CounterOfferModalNonLpg = ({
  isOpen,
  toggle,
  formData,
  onFormChange,
  onPortSetup,
  onSave,
  loading,
  saveDisabled = false,
  errors = {},
  form,
  incotermTypeOptions,
  incotermRouteOptions: _incotermRouteOptions,
  incotermLocationOptions,
  fobRouteOptions,
}) => {
  const isFobIncoterm = formData.incotermId === FOB_INCOTERM_ID;
  const portCount = getCounterPortCount(formData);
  const showLocationQuantity = needsLocationQuantity(formData);

  const timelineLabel =
    TIMELINE_OPTIONS.find(option => option.value === formData.timelineType)
      ?.label || 'Accepted Discharged Dates';

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      backdrop='static'
      size='xl'
      scrollable
    >
      <ModalHeader toggle={toggle}>Add Counter Requirement</ModalHeader>
      <ModalBody className='p-4'>
        <CounterProductAlert form={form} />

        {loading ? (
          <CounterModalLoading />
        ) : (
          <>
            <RequiredNote />

            <FormSection
              title='Delivery terms'
              description='Incoterm, ports and route'
              columns={isFobIncoterm ? 2 : 1}
            >
              <SelectField
                label='Type'
                name='incotermId'
                required
                options={incotermTypeOptions}
                value={formData.incotermId}
                onChange={value => onFormChange('incotermId', value ?? '')}
                error={errors.incotermId}
              />

              {isFobIncoterm ? (
                <SelectField
                  label='Route'
                  name='incotermRouteId'
                  required
                  options={fobRouteOptions}
                  value={formData.incotermRouteId}
                  onChange={value =>
                    onFormChange('incotermRouteId', value ?? '')
                  }
                  error={errors.incotermRouteId}
                />
              ) : null}
            </FormSection>

            <FormSection
              title='Quantity and timeline'
              description='Total volume and what the dates mean'
              columns={3}
            >
              <CounterDeliveryBasisFields
                formData={formData}
                onFormChange={onFormChange}
              />
              <TextField
                label='Total quantity'
                name='totalQuantity'
                mode='calculated'
                value={formatParcelSize(formData.deliveryBasis)}
                hint='Total of the delivery basis'
              />
              <TextField
                label='Timeline'
                name='timelineType'
                mode='readonly'
                value={timelineLabel}
              />
            </FormSection>

            {isFobIncoterm ? (
              <CounterPortBlock
                portNo={1}
                title='Loading'
                locationField='incotermLocationId'
                multiSelectField='incotermFOB'
                isMultiSelect
                multiSelectValue={formData.incotermFOB}
                dateFromField='startDate'
                dateFromValue={formData.startDate}
                dateToField='endDate'
                dateToValue={formData.endDate}
                dateLabel='Accepted loading dates'
                showQuantity={false}
                incotermLocationOptions={incotermLocationOptions}
                onFormChange={onFormChange}
                errors={errors}
              />
            ) : formData.incotermId ? (
              <>
                <CounterPortPick
                  portCount={portCount}
                  error={
                    errors.incotermPortType || errors.incotermMultiPortType
                  }
                  onPortSetup={onPortSetup}
                />
                <CounterDischargePorts
                  formData={formData}
                  portCount={portCount}
                  showQuantity={showLocationQuantity}
                  incotermLocationOptions={incotermLocationOptions}
                  onFormChange={onFormChange}
                  errors={errors}
                />
              </>
            ) : null}
          </>
        )}
      </ModalBody>

      <CounterModalFooter
        loading={loading}
        saveDisabled={saveDisabled}
        onCancel={toggle}
        onSave={onSave}
        formData={formData}
      />
    </Modal>
  );
};

export default CounterOfferModalNonLpg;
